import { InstallationPoint } from '../../components/CustomFields/InstallationPoint';

export function getIcpNumber(installationPoint: InstallationPoint | null): string | undefined {
  return installationPoint?.id?.trim();
}

export type InstallationPointField = {
  installationPoint: InstallationPoint | null;
};
